<template>
    <div class="mt-5">
        <div class="flex items-end">
            <template v-if="dob">
                <label for="last_ssn" class="flex-1 text-sm font-medium">Please enter the last four digits of your social security number</label>
                <h6 @click="$emit('use-secondary')" :class="`flex-initial text-xs font-medium text-right cursor-pointer text-${$root.theme}-600`">
                    Or use Birth Date
                </h6>
            </template>
            <template v-else>
                <label for="last_ssn" class="flex-1 text-sm font-medium">Please enter the last four digits of your social security number:</label>
            </template>
        </div>

        <div class="mt-2 flex rounded-md shadow-sm">
            <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                XXX-XX-
            </span>
            <input :value="lastFourSsn" minlength="4" maxlength="4" @input="$emit('update:ssn', $event.target.value)" @keydown.enter="$emit('submit')" type="text" name="last_ssn" id="last_ssn" :class="`flex-1 min-w-0 block w-full bg-white px-4 py-3 rounded-none rounded-r-md focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 sm:text-sm border-gray-300 placeholder-gray-300`" placeholder="1234">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ssn', 'dob'],

        computed: {
            lastFourSsn() {
                return this.ssn;
            }
        }
    }
</script>